import { IKhoi } from "../../../model/respone/category/IKhoi";
import { eKhoiActionTypeIds } from "../../action-types/category/IKhoiActionType";
import { baseAction } from "../IActionBase";

export const khoiAction = {
    loadStart: () => baseAction(eKhoiActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: IKhoi[]) => baseAction(eKhoiActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eKhoiActionTypeIds.LOAD_ERROR, message),
}